module.exports = __webpack_public_path__ + "img/b2.4264bcc1.jpg";